<template>

  <form>
    <form-field full-width label="Group Name" name="group_name" v-model="group.name"></form-field>
  </form>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'GroupForm',

  computed: {
    ...mapState('InterestGroups',['group'])
  },
}
</script>
